import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import axios from "axios";
import {useHistory} from 'react-router-dom';
import { API_URL } from "../../constent";

import {
  Block,
  BlockHeadContent,
  BlockTitle,
  BlockBetween,
  BlockHead,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  TooltipComponent,
  PaginationComponent,
  PreviewAltCard,
  Row,
  Col,
  RSelect,
} from "../../components/Component";

import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem, Button, Modal, ModalBody } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom/cjs/react-router-dom";

const Usercomparison = ({match }) => {

  const poposer_id = match.params.id;

  const { errors, register, handleSubmit } = useForm();
  
  const [data, setData] = useState([]);
  const [smOption, setSmOption] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getload, getLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [stage, setStage] = useState([]);
  const [proposer, setProposer] = useState([]);
  const [copydata, setCopydata] = useState(0);

  const history = useHistory();

  const [view, setView] = useState({
    add: false,
    details: false,
  });
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);

  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = data.filter((item) => {
        return item.name.toLowerCase().includes(onSearchText.toLowerCase())
      });
      setData(filteredObject);
    } else {

        var userData = JSON.parse(localStorage.getItem('userData'));
        var getuserid = userData?.[0]?.id;
        
        axios.get(`${API_URL}getusercomparisonlist/${poposer_id}`).then((result)=>
        {
            console.log(result.data);
            setData(result.data);
            getLoading(false);
        })
        axios.post(`${API_URL}getcategory`).then((result)=>
        {
            console.log(result.data);
            setStage(result.data);
        })
        axios.post(`${API_URL}getproposer`).then((result)=>
        {
            console.log(result.data);
            setProposer(result.data);
        })


    }
  }, [onSearchText , refresh]);

  if (getload) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  // toggle function to view order details
  const toggle = (type) => {
   
    setView({
      add: type === "add" ? true : false,
      details: type === "details" ? true : false,
    });
  };

  // selects all the order
  const selectorCheck = (e) => {
    let newData;
    newData = data.map((item) => {
      item.check = e.currentTarget.checked;
      return item;
    });
    setData([...newData]);
  };

  // selects one order
  const onSelectChange = (e, id) => {
    let newData = data;
    let index = newData.findIndex((item) => item.id === id);
    newData[index].check = e.currentTarget.checked;
    setData([...newData]);
  };

  
  const onFormSubmit = (form) => {

    const { comparison_name, description, category , proposer } = formData;

    var userData = JSON.parse(localStorage.getItem('userData'));
    var getuserid = userData?.[0]?.id;

    const formdata = new FormData() 
    formdata.append('comparison_name' , comparison_name);
    formdata.append('description' , description);
    formdata.append('category' , category);
    formdata.append('user_id' , getuserid);
    formdata.append('proposer' , proposer);
    formdata.append('copydata' , copydata);

    setLoading(true);


    axios.post( `${API_URL}addcomparison`, formdata)
    .then((response)=>{
        console.log(response.data);
        if(response.data.status === 1){
            setLoading(false);
            setRefresh(true);
            onFormCancel();
            history.push('/comparisonlist');
        }else{
            setLoading(false);
            alert(response.data.msg);
        }
    })
  };


  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, details: false });
    setCopydata(0);
    setFormData([]);
  };

  // function to delete a Order
  const deleteOrder = (id) => {

    axios.get(`${API_URL}deletecomparison/${id}`).then((result)=>
    {
        console.log(result.data);
        setRefresh(!true);
    })

  };

  const copyOrder = (id) =>{
        axios.get(`${API_URL}singlecomparison/${id}`).then((result)=>
        {
            console.log(result.data[0]);
            formData['comparison_name'] = result.data[0]['name'];
            formData['description'] = result.data[0]['description'];
            formData['proposer'] = result.data[0]['proposer'];
            formData['category'] = result.data[0]['category'];
            setCopydata(id);
            toggle("add");
        })
  }


  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  

  return (
    <React.Fragment>
      <Head title="Comparison List"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Comparison List</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <Icon name="search"></Icon>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Search by Comparison Name"
                          onChange={(e) => onFilterChange(e)}
                        />
                      </div>
                    </li>
                    {/* <li className="nk-block-tools-opt">
                      <Button
                        className="toggle d-none d-md-inline-flex"
                        color="primary"
                        onClick={() => {
                          toggle("add");
                        }}
                      >
                        <Icon name="plus"></Icon>
                        <span>Add Comparison</span>
                      </Button>
                    </li> */}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="nk-tb-list is-separate is-medium mb-3">
            <DataTableHead className="nk-tb-item">
              
              <DataTableRow>
                <span className="sub-text">Comparison Name</span>
              </DataTableRow>
              <DataTableRow size="md">
                <span className="sub-text">Description</span>
              </DataTableRow>
              <DataTableRow>
                <span className="sub-text">Category</span>
              </DataTableRow>
              <DataTableRow size="sm">
                <span className="sub-text">Status</span>
              </DataTableRow>
              <DataTableRow className="text-right">
                <span className="sub-text">Action</span>
              </DataTableRow>

            </DataTableHead>

            {currentItems.length > 0
              ? currentItems.map((item) => (
                  <DataTableItem key={item.id}>

                    <DataTableRow>
                       {item.name}
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span>{item.description}</span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <span>{item.category_name}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span
                        className={`dot bg-${item.status === 1 ? "success" : "warning"} d-mb-none`}
                      ></span>
                      <span
                        className={`badge badge-sm badge-dot has-bg badge-${
                          item.status === 1 ? "success" : "warning"
                        } d-none d-mb-inline-flex`}
                      >
                        {item.status === 1 ? "Active" : "Inactive" }
                      </span>
                    </DataTableRow>

                    <DataTableRow className="text-right">
                        <button className="btn btn-sm btn-info" onClick={(ev) => {
                                      ev.preventDefault();
                                      deleteOrder(item.id);
                                    }}> <Icon name="trash"></Icon>
                                    <span>Delete</span> </button> &nbsp;&nbsp;
                                    {item.data_count > 0 ? (
                                    <Link to={`/updatecomparison/${item.id}`} className="btn btn-sm btn-info">Update Report</Link>
                                    ) : (
                                    <Link to={`/addcomparison/${item.id}`} className="btn btn-sm btn-info">Create Report</Link>
                                    )} &nbsp;&nbsp;

                        <Link to={`/showcomparison/${item.id}`} className="btn btn-sm btn-info"> View Report</Link> &nbsp;&nbsp;

                        {/* <button type="button" className="btn btn-sm btn-info" onClick={() => {copyOrder(item.id);}}><span>Duplicate</span> </button> */}

                    </DataTableRow>
                  
                  </DataTableItem>
                ))
              : null}
          </div>
          <PreviewAltCard>
            {data.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={data.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No orders found</span>
              </div>
            )}
          </PreviewAltCard>
        </Block>

        <Modal isOpen={view.add} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Comparison</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                           Comparison Name
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="comparison_name"
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.comparison_name}
                          />
                          {errors.comparison_name && <span className="invalid">{errors.comparison_name.message}</span>}
                        </div>
                      </div>
                    </Col>
            
                    <Col lg="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="description">
                          Description
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="description"
                            onChange={(e) => onInputChange(e)}
                            defaultValue={formData.description}
                          />
                          {errors.description && <span className="invalid">{errors.description.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col lg="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="proposer">
                           Proposer
                        </label>
                        <div className="form-control-wrap">
                          <select className="form-control" defaultValue={formData.proposer} name="proposer" onChange={(e) => onInputChange(e)}>
                             <option value="0">Select Proposer</option> 
                             {
                                proposer.map((item) => (
                                    <option value={item.id}>{item.fullname}</option>
                                ))
                              }
                          </select>

                          {errors.proposer && <span className="invalid">{errors.proposer.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col lg="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="category">
                          Category
                        </label>
                        <div className="form-control-wrap">
                          <select className="form-control" defaultValue={formData.category} name="category" onChange={(e) => onInputChange(e)}>
                             <option value="0">Select Category</option> 
                             {
                                stage.map((item) => (
                                    <option value={item.id}>{item.category_name}</option>
                                ))
                              }
                          </select>

                          {errors.category && <span className="invalid">{errors.category.message}</span>}
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" disabled={loading} type="submit">
                        <Icon className="plus"></Icon>
                        <span>{loading ? 'Loading...' : 'Add Comparison'}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

      </Content>
    </React.Fragment>
  );
};

export default Usercomparison;
